import { UiStack } from '@experiences/ui-common';
import { ApButton } from '@uipath/portal-shell-react';
import React, { useCallback } from 'react';

interface StepNavigationProps {
    onNext: () => void;
    onBack?: () => void;
    nextLabel?: string;
    backLabel?: string;
    disableNext?: boolean;
    disableBack?: boolean;
}

export const GovernancePolicyStepNavigation: React.FC<StepNavigationProps> = ({
    onNext,
    onBack,
    nextLabel = 'Next',
    backLabel = 'Back',
    disableNext = false,
    disableBack = false,
}) => {
    const handleNext = useCallback(() => {
        if (!disableNext) {
            onNext();
        }
    }, [ disableNext, onNext ]);

    const handleBack = useCallback(() => {
        if (!disableBack && onBack) {
            onBack();
        }
    }, [ disableBack, onBack ]);

    return (
        <UiStack
            p={3}
            direction="row"
            gap={10}
            justify="end"
            align="center"
        >
            {onBack && <ApButton
                variant="secondary"
                onClick={handleBack}
                disabled={disableBack}
                data-cy="step-back-button"
                label={backLabel}
            />}
            <ApButton
                variant="primary"
                onClick={handleNext}
                disabled={disableNext}
                data-cy="step-next-button"
                label={nextLabel}
            />
        </UiStack>
    );
};
